"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HubConfigurationBuilder = void 0;
class HubConfigurationBuilder {
    constructor() {
        this.isEnabled = false;
        this.isDebug = false;
        this.accessTokenFactory = () => '';
        this.hubDefinitions = {};
    }
    enableHubs(isEnabled) {
        this.isEnabled = isEnabled;
        return this;
    }
    setDebugMode(isDebug) {
        this.isDebug = isDebug;
        return this;
    }
    registerAccessTokenFactory(accessTokenFactory) {
        this.accessTokenFactory = accessTokenFactory;
        return this;
    }
    add(factory, url, authorization, isEnabled, handlers) {
        this.hubDefinitions[factory.id] = { url, factory, authorization, isEnabled, handlers };
        return this;
    }
    build() {
        if (this.isEnabled) {
            return {
                hubDefinitions: Object.values(this.hubDefinitions).filter((x) => x.isEnabled),
                isEnabled: this.isEnabled,
                isDebug: this.isDebug,
                accessTokenFactory: this.accessTokenFactory,
            };
        }
        return {
            hubDefinitions: [],
            isEnabled: false,
            isDebug: false,
            accessTokenFactory: () => '',
        };
    }
}
exports.HubConfigurationBuilder = HubConfigurationBuilder;
